import { api } from '../../../apiAxios';
import { urlHttpGov } from '../../../urls';
import { getToken } from '../../../LStorage/token';

class RecibosCadastrarService {
    private baseURLOriginal: string = `${urlHttpGov}`;
    private baseURL: string = `${urlHttpGov}${process.env.REACT_APP_BACKEND === 'local' ? '' : '/gestor'}/receipt`;

    async getRecibos(id: any, signal?: AbortSignal): Promise<any> {

        let { data } = await api.get(`${this.baseURL}/${id}`,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                },
                signal
            });

        return data;
    }

    async postRecibos(
        obj: any,
        signal?: AbortSignal
    ): Promise<any> {

        let { data } = await api.post(`${this.baseURL}`,
            obj,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                },
                signal
            });

        return data;
    }

    async putRecibos(
        id: number,
        obj: any,
        signal?: AbortSignal
    ): Promise<any> {

        let { data } = await api.put(`${this.baseURL}/${id}`,
            obj,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                },
                signal
            });

        return data;
    }

    async deleteRecibos(
        id: number,
        signal?: AbortSignal
    ): Promise<any> {

        let { data } = await api.delete(`${this.baseURL}/${id}`,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                },
                signal
            });

        return data;
    }

    async getCidades(
        signal?: AbortSignal
    ): Promise<any> {

        let { data } = await api.get(`${this.baseURLOriginal}/backend/cidades`,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                },
                signal
            });

        return data;
    }


    async getPrintRecibos(
        id: number,
        signal?: AbortSignal
    ): Promise<any> {

        let { data } = await api.get(`${this.baseURL}/print/${id}`,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                },
                responseType: 'blob',
                signal
            });

        return data;
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new RecibosCadastrarService();
